import color from 'color';
import classnames from 'classnames';
import { sum } from 'lodash';
import { getTextAlign } from './get-text-align';
export function prop(name) {
    return function (values) {
        return values
            .filter(function (_) { return !!_; })
            .map(function (_) { return _[name]; })
            .find(function (value) {
            if (typeof value === 'number') {
                return true;
            }
            return !!value;
        });
    };
}
function integer(value) {
    return parseInt(value, 10) || 0;
}
export function shorthand(value) {
    return value
        ? [value.top, value.right, value.bottom, value.left]
            .filter(function (_) { return _ !== undefined || _ !== null; })
            .map(function (_) { return _ + "px"; })
            .join(' ')
        : '';
}
export function spacingToCssProperties(outerSpacing, innerSpacing) {
    return {
        marginTop: outerSpacing.top,
        marginLeft: outerSpacing.left,
        marginBottom: outerSpacing.bottom,
        marginRight: outerSpacing.right,
        paddingTop: innerSpacing.top,
        paddingLeft: innerSpacing.left,
        paddingBottom: innerSpacing.bottom,
        paddingRight: innerSpacing.right,
    };
}
export function margin(values) {
    return {
        top: integer(prop('marginTop')(values)),
        right: integer(prop('marginRight')(values)),
        bottom: integer(prop('marginBottom')(values)),
        left: integer(prop('marginLeft')(values)),
    };
}
export function padding(values) {
    return {
        top: integer(prop('paddingTop')(values)),
        right: integer(prop('paddingRight')(values)),
        bottom: integer(prop('paddingBottom')(values)),
        left: integer(prop('paddingLeft')(values)),
    };
}
export function textAlign(isRtl) {
    return function (values) {
        return getTextAlign(prop('textAlign')(values), isRtl ? 'right' : 'left');
    };
}
var maxPaddingInApes = 24;
export function getTopBottomPaddingRestrictionCssClass(values) {
    return classnames(getTopPaddingRestrictionCssClass(values), getBottomPaddingRestrictionCssClass(values));
}
export function getBottomPaddingRestrictionCssClass(values) {
    var regionPadding = padding(values);
    if (regionPadding.bottom && regionPadding.bottom > maxPaddingInApes) {
        return 'PB24';
    }
    return '';
}
export function getTopPaddingRestrictionCssClass(values) {
    var regionPadding = padding(values);
    if (regionPadding.top && regionPadding.top > maxPaddingInApes) {
        return 'PT24';
    }
    return '';
}
export function calculateColumnsWidths(contentWidth, columns, innerPadding, isRtl) {
    var calculatedColumns = columns.map(function (column) { return (contentWidth / 100) * column; });
    var leftover = contentWidth - sum(calculatedColumns);
    var columnCount = columns.length;
    var firstColumnPadding = isRtl
        ? innerPadding.right || 0
        : innerPadding.left || 0;
    var lastColumnPadding = isRtl
        ? innerPadding.left || 0
        : innerPadding.right || 0;
    var last = columnCount - 1;
    calculatedColumns[0] = calculatedColumns[0] + firstColumnPadding;
    calculatedColumns[last] = calculatedColumns[last] + lastColumnPadding;
    if (leftover > 0) {
        var middleColumn = Math.floor(last / 2);
        calculatedColumns[middleColumn] =
            calculatedColumns[middleColumn] + leftover;
    }
    return calculatedColumns;
}
export function calculateColumnsProportions(contentWidth, columns, innerPadding, isRtl) {
    var columnsWidths = calculateColumnsWidths(contentWidth, columns, innerPadding, isRtl);
    var fullWidth = contentWidth + (innerPadding.left || 0) + (innerPadding.right || 0);
    var percents = columnsWidths.map(function (val) { return (val / fullWidth) * 100; });
    return percents;
}
export function paddingToString(p) {
    return p
        ? (p.top || 0) + "px " + (p.right || 0) + "px " + (p.bottom || 0) + "px " + (p.left || 0) + "px"
        : '';
}
export function getRegionMobileCssClass(values, applyVerticalPaddingRestrictions) {
    if (applyVerticalPaddingRestrictions === void 0) { applyVerticalPaddingRestrictions = false; }
    var regionPadding = padding(values);
    var regionMargin = margin(values);
    var hasBackgroundColor = isSolidColor(prop('backgroundColor')(values));
    var hasBorder = hasWidth(prop('borderWidth')(values)) &&
        isSolidColor(prop('borderColor')(values));
    var classList = [];
    if (hasBackgroundColor || hasBorder) {
        regionPadding.top && classList.push('PT16');
        regionPadding.right && classList.push('PR16');
        regionPadding.bottom && classList.push('PB16');
        regionPadding.left && classList.push('PL16');
        regionMargin.right && classList.push('MR16');
        regionMargin.left && classList.push('ML16');
    }
    else {
        (regionPadding.left || regionMargin.left) && classList.push('ML16', 'PL0');
        (regionPadding.right || regionMargin.left) && classList.push('MR16', 'PR0');
        if (applyVerticalPaddingRestrictions) {
            if (regionPadding.top && regionPadding.top > maxPaddingInApes) {
                classList.push('PT24');
            }
            if (regionPadding.bottom && regionPadding.bottom > maxPaddingInApes) {
                classList.push('PB24');
            }
        }
    }
    return classList.join(' ');
}
function isSolidColor(value) {
    if (value) {
        try {
            return color(value).alpha() !== 0;
        }
        catch (err) {
            console.log(err);
        }
    }
    return false;
}
function hasWidth(value) {
    return !!integer(value);
}
//# sourceMappingURL=css-utils.js.map